<form [formGroup]="form" (ngSubmit)="save()" class="class-form">
  <div class="scope-note" *ngIf="isClassEventEdit">
    <mat-icon inline="true">{{
      data.classEventEditType === 2 ? "repeat" : "event"
    }}</mat-icon>
    {{
      data.classEventEditType === 2
        ? "Editing this and all following events"
        : "Editing this class"
    }}
  </div>
  <div class="edit-scope-hint" *ngIf="editScopeHint">
    <mat-icon inline="true">info_outline</mat-icon> {{ editScopeHint }}
  </div>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Title</mat-label>
    <input
      matInput
      formControlName="title"
      placeholder="Class or event name"
      cdkFocusInitial
    />
    <mat-error *ngIf="f['title'].invalid" style="margin-left: -9px"
      >Title is required</mat-error
    >
  </mat-form-field>

  <div class="row type-row">
    <mat-form-field appearance="outline" class="half-width">
      <mat-label>Type</mat-label>
      <mat-select formControlName="type">
        <mat-option [value]="1">In-Person</mat-option>
        <mat-option [value]="2">Live Online</mat-option>
        <mat-option [value]="3">Hybrid (In-Person &amp; Online)</mat-option>
      </mat-select>
      <mat-error *ngIf="f['type'].invalid" style="margin-left: -9px"
        >Type is required</mat-error
      >
    </mat-form-field>
    <mat-form-field appearance="outline" class="half-width">
      <mat-label>Subject</mat-label>
      <mat-select formControlName="subject">
        <mat-option [value]="1">Math</mat-option>
        <mat-option [value]="2">English</mat-option>
        <mat-option [value]="3">Math and English</mat-option>
        <mat-option [value]="4">Science</mat-option>
      </mat-select>
      <mat-error *ngIf="f['subject'].invalid" style="margin-left: -9px"
        >Subject is required</mat-error
      >
    </mat-form-field>
  </div>

  <div class="row tutor-row">
    <mat-form-field appearance="outline" class="half-width">
      <mat-label>Tutor</mat-label>
      <mat-select formControlName="tutor">
        <mat-option *ngFor="let tutor of tutors" [value]="tutor['tutorName']">
          {{ tutor["tutorName"] }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="f['tutor'].invalid" style="margin-left: -9px"
        >Tutor is required</mat-error
      >
    </mat-form-field>
    <mat-form-field appearance="outline" class="half-width">
      <mat-label>Time Zone</mat-label>
      <mat-select formControlName="timeZone">
        <mat-option [value]="1">Eastern Time</mat-option>
        <mat-option [value]="2">Center Time</mat-option>
        <mat-option [value]="3">Mountain Time</mat-option>
        <mat-option [value]="4">Pacific Time</mat-option>
        <mat-option [value]="5">Indian Time</mat-option>
      </mat-select>
      <mat-error *ngIf="f['timeZone'].invalid" style="margin-left: -9px"
        >Time zone required</mat-error
      >
    </mat-form-field>
  </div>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Location or meeting link</mat-label>
    <input
      matInput
      formControlName="location"
      placeholder="e.g. Room 4B or https://meet.google.com/..."
    />
  </mat-form-field>

  <div class="row when-row">
    <div class="when-fields">
      <div class="row mb-[12px]">
        <mat-form-field appearance="outline" class="half-width">
          <mat-label>{{ isClassEventEdit ? "Date" : "Start date" }}</mat-label>
          <input matInput type="date" formControlName="startDate" />
          <mat-hint *ngIf="classWeek">{{ classWeekLabel }}</mat-hint>
          <mat-error
            *ngIf="f['startDate'].hasError('outsideWeek')"
            style="margin-left: -9px"
            >Pick a day from {{ classWeekLabel }}</mat-error
          >
        </mat-form-field>
        <mat-form-field
          appearance="outline"
          class="half-width"
          *ngIf="!isClassEventEdit"
        >
          <mat-label>End date</mat-label>
          <input matInput type="date" formControlName="endDate" />
        </mat-form-field>
      </div>
      <div class="row">
        <mat-form-field appearance="outline" class="half-width">
          <mat-label>Start time</mat-label>
          <input matInput type="time" formControlName="startTime" />
        </mat-form-field>
        <mat-form-field appearance="outline" class="half-width">
          <mat-label>End time</mat-label>
          <input matInput type="time" formControlName="endTime" />
        </mat-form-field>
      </div>

      <ng-container *ngIf="!isEditMode">
        <div class="repeat-days">
          <span class="repeat-days-label">Repeat on</span>
          <mat-checkbox
            *ngFor="let day of weekDays"
            [checked]="isRepeatDaySelected(day.value)"
            (change)="toggleRepeatDay(day.value, $event.checked)"
          >
            {{ day.label }}
          </mat-checkbox>
        </div>

        <mat-form-field
          appearance="outline"
          class="full-width repeat-frequency-field"
        >
          <mat-label>Repeat frequency</mat-label>
          <mat-select formControlName="repeatIntervalWeeks">
            <mat-option
              *ngFor="let interval of repeatIntervals"
              [value]="interval.value"
            >
              {{ interval.label }}
            </mat-option>
          </mat-select>
          <mat-hint>{{ repeatFrequencyHint }}</mat-hint>
        </mat-form-field>
      </ng-container>

      <div class="viewer-time-hint" *ngIf="viewerTimeHint">
        <mat-icon inline="true">public</mat-icon> {{ viewerTimeHint }}
      </div>

      <div class="duration-chip mt-[16px] ml-[8px]" *ngIf="durationLabel">
        <mat-icon inline="true">hourglass_empty</mat-icon> {{ durationLabel }}
      </div>
      <div class="form-level-error" *ngIf="form.errors?.['dateRange']">
        End date cannot be before start date.
      </div>
      <div class="form-level-error" *ngIf="form.errors?.['batchRange']">
        Schedule dates must be within the batch ({{ batchRangeLabel }}).
      </div>
      <div class="form-level-error" *ngIf="form.errors?.['timeRange']">
        End time cannot be before or equal to start time.
      </div>
      <div class="form-level-warning" *ngIf="isPast">
        <mat-icon inline="true">warning</mat-icon> This start time is in the
        past.
      </div>
    </div>
  </div>

  <div
    class="form-level-error overlap-error"
    *ngIf="
      form.errors?.['overlap'] && (f['tutor'].touched || f['startDate'].touched)
    "
  >
    <mat-icon inline="true">error_outline</mat-icon>
    {{ f["tutor"].value }} is already booked on "{{
      form.errors?.["overlap"].title
    }}"<span *ngIf="form.errors?.['overlap'].date">
      on {{ form.errors?.["overlap"].date }}</span
    >
    during this time.
  </div>

  <div class="hide-details" *ngIf="canHideDetails">
    <mat-checkbox formControlName="hideDetails" color="primary"
      >Don't show schedule</mat-checkbox
    >
    <span class="hide-details-hint"
      >Students see only the title on this day, e.g. for a holiday.</span
    >
  </div>

  <div class="actions">
    <span class="spacer"></span>
    <button mat-button type="button" (click)="cancel()">Cancel</button>
    <button
      mat-raised-button
      color="primary"
      type="submit"
      [disabled]="saving"
    >
      {{ isEditMode ? "Save Changes" : "Save" }}
    </button>
  </div>
</form>
